import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Veículos', href: '#veiculos' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Contato', href: '#contato' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#C0C0C0]/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-24">
        {/* Logo */}
        <a href="#home" onClick={() => handleNav('#home')} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/64d89e01f0da6e76491ec791e8d4af31.png"
            alt="Miki Motors"
            className="h-20 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="text-sm font-medium text-white/80 hover:text-[#D4D4D4] transition-colors duration-300 tracking-wide cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA Button */}
        <a
          href="https://api.whatsapp.com/send/?phone=5519997889998&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-[#C0C0C0] text-black text-sm font-bold px-5 py-2.5 rounded-full hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-base"></i>
          Fale Conosco
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0A0A0A]/98 backdrop-blur-md border-t border-[#C0C0C0]/20 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="text-white/80 hover:text-[#D4D4D4] text-base font-medium text-left transition-colors cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://api.whatsapp.com/send/?phone=5519997889998&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[#C0C0C0] text-black text-sm font-bold px-5 py-3 rounded-full justify-center cursor-pointer"
          >
            <i className="ri-whatsapp-line"></i>
            Fale Conosco
          </a>
        </div>
      )}
    </header>
  );
}
